export const signIn = {
  local: "https://op-mlogin.plaync.com/login/signin",
  rc: "https://rc-mlogin.plaync.com/login/signin",
  live: "https://mlogin.plaync.com/login/signin"
};

export const signOut = {
  local: "https://op-mlogin.plaync.com/login/signout",
  rc: "https://rc-mlogin.plaync.com/login/signout",
  live: "https://mlogin.plaync.com/login/signout"
};
